import React from "react";
import { Toast } from "primereact/toast";
import { AppLayoutProvider, useAppLayout } from "./AppLayoutContext";
import { Loader } from "./Loader";
import "./AppLayout.css";

function AppLayoutContent({ children }: { children: React.ReactNode }) {
  const { toastRef } = useAppLayout();

  return (
    <div className="app-layout">
      <Toast ref={toastRef} position="top-right" />
      <main className="app-layout__main">{children}</main>
      <Loader />
    </div>
  );
}

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <AppLayoutProvider>
      <AppLayoutContent>{children}</AppLayoutContent>
    </AppLayoutProvider>
  );
}
